import * as React from "react";
const Search = (props) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.584 18.125c-4.708 0-8.542-3.834-8.542-8.542s3.834-8.541 8.542-8.541 8.542 3.833 8.542 8.541-3.834 8.542-8.542 8.542m0-15.833c-4.025 0-7.292 3.274-7.292 7.291s3.267 7.292 7.292 7.292 7.291-3.275 7.291-7.292-3.266-7.291-7.291-7.291m8.75 16.667a.62.62 0 0 1-.442-.183l-1.666-1.667a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0l1.666 1.666a.63.63 0 0 1 0 .884.62.62 0 0 1-.441.183"
            fill="#BAC2C3"
        />
    </svg>
);
export default Search;
